import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;

export default () => ({
    swiper: null,
    init() {
        this.checkBreakpoint();

        this.startLightbox();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.productImagesCarousel, {
            slidesPerView: 1.5,
            spaceBetween: 12,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                    pagination: false,
                    direction: 'horizontal',
                },
                768: {
                    slidesPerView: 2.5,
                    pagination: false,
                    direction: 'horizontal',
                },
                1280: {
                    slidesPerView: 1,
                    pagination: false,
                    direction: 'vertical',
                },
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });
    },
    startLightbox() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '#productMedia',
            pswpModule: () => import('photoswipe'),
            bgOpacity: 1,
            showHideOpacity: true,
            children: 'a',
            loop: true,
            showHideAnimationType: 'zoom',
            imageClickAction: 'zoom',
            tapAction: 'zoom',
            mouseMovePan: true,
            initialZoomLevel: 'fit',
            secondaryZoomLevel: 1.2,
            maxZoomLevel: 1,
            zoom: true,
            close: true,
            counter: true,
            arrowKeys: true,
            wheelToZoom: true,
        });

        lightbox.init();

        lightbox.on('change', () => {
            const {pswp} = lightbox;

            if (this.swiper) {
                this.swiper.slideTo(pswp.currIndex, 0, false);
            }
        });

        lightbox.on('afterInit', () => {
            const {pswp} = lightbox;

            if (this.swiper && this.swiper.params.autoplay.enabled) {
                this.swiper.autoplay.stop();
            }
        });

        lightbox.on('closingAnimationStart', () => {
            const {pswp} = lightbox;

            if (this.swiper) {
                this.swiper.slideTo(pswp.currIndex, 0, false);
                if (this.swiper.params.autoplay.enabled) {
                    this.swiper.autoplay.start();
                }
            }
        });
    },

    checkBreakpoint() {
        const mediaQuery = '(max-width: 1279px)';
        const mediaQueryList = window.matchMedia(mediaQuery);

        if (mediaQueryList.matches) {
            this.enable();
        } else {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
        }

        mediaQueryList.addEventListener('change', event => {
            if (event.matches) {
                this.enable();
            } else {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                }
            }
        });
    },
});
